/*
 * 2026-01-24: SK - Added "add2Cart2" function to simplify adding to cart by passing a single ID, be it variant or product.
*/
function addToCart(submitBtn, productId, variantId) {  
  var quantity = 1; // You can adjust the quantity as needed
  const appendedId = variantId ? variantId : productId;
  var formData = new FormData(document.getElementById('form--' + appendedId));
  var cartDrawer = document.querySelector('cart-drawer');

  submitBtn.setAttribute('aria-disabled', 'true');
  submitBtn.classList.add('is-loading');
      let sections = 'cart-icon-bubble';
    if (cartDrawer) {
      sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
    }
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sections);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) { 
    
    if (cartDrawer) {
            cartDrawer.renderContents(
              data, true
            );
          } 

          submitBtn.classList.add('is-success');
          setTimeout(function() {
              submitBtn.classList.remove('is-loading');
              submitBtn.classList.remove('is-success');
          }, 1400); 

  })
  .catch(function(error) {
    console.error('Error adding to cart:', error);
  });
}

function addToCart2(submitBtn, selectedID) {  
  var quantity = 1; // You can adjust the quantity as needed
  //const appendedId = variantId ? variantId : productId;
  var formData = new FormData(document.getElementById('form--' + selectedID));
  var cartDrawer = document.querySelector('cart-drawer');

  submitBtn.setAttribute('aria-disabled', 'true');
  submitBtn.classList.add('is-loading');
      let sections = 'cart-icon-bubble';
    if (cartDrawer) {
      sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
    }
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sections);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) { 
    
    if (cartDrawer) {
            cartDrawer.renderContents(
              data, true
            );
          } 

          submitBtn.classList.add('is-success');
          setTimeout(function() {
              submitBtn.classList.remove('is-loading');
              submitBtn.classList.remove('is-success');
          }, 1400); 

  })
  .catch(function(error) {
    console.error('Error adding to cart:', error);
  });
}